import React from "react";
import { FaVolumeUp, FaSpinner } from "react-icons/fa";

interface TapToEnableAudioProps {
  onEnable: () => void;
  isUnlocking: boolean;
}

const TapToEnableAudio: React.FC<TapToEnableAudioProps> = ({ onEnable, isUnlocking }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm">
    <button
      onClick={onEnable}
      disabled={isUnlocking}
      className={`flex flex-col items-center p-6 bg-white bg-opacity-90 rounded-xl border-2 border-qatar-maroon ${
        isUnlocking ? 'cursor-wait' : 'hover:bg-qatar-gold/30 animate-bounce'
      }`}
    >
      {isUnlocking ? (
        <FaSpinner className="text-qatar-maroon text-5xl mb-2 animate-spin" />
      ) : (
        <FaVolumeUp className="text-qatar-maroon text-5xl mb-2 animate-pulse" />
      )}
      <span className="text-lg font-medium text-qatar-maroon">
        {isUnlocking ? 'Unlocking...' : 'Tap to enable audio'}
      </span>
      {!isUnlocking && (
        <span className="text-xs text-qatar-sunset mt-1">To continue, please allow us to play the speech.</span>
      )}
    </button>
  </div>
);

export default TapToEnableAudio; 